import React, { useEffect, useState } from "react";
import "./product.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useCartContext } from "../../contexts/CartContext";
import Cookies from "js-cookie";
import { TbTruckDelivery, TbListDetails } from "react-icons/tb";
import { FaInfoCircle } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton } from 'react-share';
import { FacebookIcon, WhatsappIcon, TwitterIcon } from 'react-share';
import { Helmet } from 'react-helmet';


const Product = () => {
  const { cart, addProduct } = useCartContext();
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();
  const [checkOut, setCheckOut] = useState(false);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const id = useParams();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const shareUrl = window.location.href; // Current page URL

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/products/getproduct/${id.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              token: Cookies.get("token"),
            },
          }
        );
        
        const productData = res.data;
        setProduct(productData);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching product:", err);
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id.id]);

  useEffect(() => {
    if (!product) return;
    const inCart = cart?.filter((item) => item._id === product.sku).length > 0;
    setCheckOut(inCart);
  }, [product, cart]);

  const HandleAddCart = () => {
    if (!cart?.filter((elem) => elem._id === product.sku).length > 0) {
      addProduct(
        {
          _id: product.sku,
          title: product.Description,
          price: product.finalPrice || 0,
          images: [product.ProductimageURL],
          quantity: quantity,
          total: (product.finalPrice || 0) * quantity,
        },
        quantity,
        (product.finalPrice || 0) * quantity
      );
    }
    navigate("/cart");
  };

  if (loading || !product) return <p>LOADING!</p>;

  // Build image array dynamically
  const images = [
    product.ProductimageURL,
    product.ProductimageURL2,
    product.ProductimageURL3,
    product.ProductimageURL4,
    product.ProductimageURL5
  ].filter((url) => url); // Remove empty strings

  return (
    <>
      {product && (
        <Helmet>
          <title>{product.Description ? `${product.Description} - Buy Online` : "Product Details"}</title>
          <meta name="description" content={product.description} />
          <meta name="keywords" content={`${product.Description}, buy, online, ${product.Description}, comprar, en línea`} />
        </Helmet>
      )}

      <div className="Product mt-3">
        <div className="d-md-flex justify-content-between canvas">
          <div className="d-lg-flex flex-lg-row-reverse Slider me-lg-5 me-md-3" style={{ width: "45%" }}>
            <Swiper
              style={{
                "--swiper-navigation-color": "#fff",
                "--swiper-pagination-color": "#fff",
              }}
              loop={true}
              spaceBetween={10}
              navigation={true}
              thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
              modules={[FreeMode, Navigation, Thumbs]}
              className="mySwiper2"
            >
              {images.map((img, index) => (
                <SwiperSlide key={index}>
                  <div
                    style={{ background: `url(${img}) center/cover no-repeat`, height: "400px" }}
                    className="productImg"
                  ></div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="details w-100">
            <p className="text-muted d-md-block d-none" style={{ wordSpacing: "5px" }}>
              Home › {product.Category} ›{" "}
              <span className="fw-bold text-dark">{product.Subcategory}</span>
            </p>

            <h1 className="fw-bold fs-2 mt-3">{product.Description}</h1>
            <h1 className="fw-bold fs-2 mt-3 price">{((product.finalPrice || 0) * quantity)?.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</h1>

            <div className="d-flex align-items-center mt-3">
              <button className="text-white btn px-3 py-1 fs-5 bg_prim" onClick={() => setQuantity(Math.max(quantity - 1, 1))}>-</button>
              <p className="px-5 fw-bold fs-5">{quantity}</p>
              <button className="text-white btn px-3 py-1 fs-5 bg_prim" onClick={() => setQuantity(quantity + 1)}>+</button>
            </div>

            <div className="mt-3" style={{ color: "#606060" }}>
              <p>Impuestos incluidos</p>
              <p className="mt-1"><FaInfoCircle color="black" size={22} /> Canon Digital <b>3,25 €</b> incluido en el precio.</p>
              <p style={{ color: "green" }} className="mt-2">
                <TbTruckDelivery color="green" size={30} />  ¡Envío gratis! *
              </p>
              <small>*Excluido Ceuta y Melilla</small>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
              <span className="mb-0">COMPARTIR</span>
              <FacebookShareButton url={shareUrl} quote={`Check out this product: ${product.Description}`}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton url={shareUrl} title={`Check out this product: ${product.Description}`}>
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <WhatsappShareButton url={shareUrl} title={`Check out this product: ${product.Description}`}>
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>
            </div>

            {!checkOut ? (
              <div className="d-flex mt-3">
                <button className="cartBtn" onClick={HandleAddCart}>COMPRAR</button>
                <button className="cartBtn ms-3" onClick={() => navigate("/")}>VOLVER A TIENDA</button>
              </div>
            ) : (
              <button className="cartBtn mt-3">Continue to checkout</button>
            )}

            <div className="description mt-3">
              <div className="d-flex align-items-center justify-content-between py-3 border-bottom" style={{ maxWidth: "500px", cursor: "pointer" }}
                data-bs-toggle="modal" data-bs-target="#staticBackdrop" >
                <div className="d-flex align-items-center gap-3">
                  <TbListDetails size={30} />
                  <span className="fw-bold">Características técnicas</span>
                </div>
                <MdKeyboardArrowRight />
              </div>
              <p className="fw-bold mt-3">Product Description:</p>
              <p>{product.Description}</p>
            </div>
          </div>
        </div>

        {/* Modal */}
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false"
          tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog TecsModal modal-dialog-scrollable modal-dialog-centered mx-auto
          justify-content-center" style={{ maxWidth: "1000px", width: "90%" }}>
            <div className="modal-content w-100">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="staticBackdropLabel">Características técnicas</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <table className="mt-2 w-100">
                  <tbody>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Marca</td>
                      <td className="ps-5 py-1">{product.Brand}</td>
                    </tr>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Modelo</td>
                      <td className="ps-5 py-1">{product.Description}</td>
                    </tr>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Peso</td>
                      <td className="ps-5 py-1">{product.Weight} kg</td>
                    </tr>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Altura</td>
                      <td className="ps-5 py-1">{product.Height} cm</td>
                    </tr>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Ancho</td>
                      <td className="ps-5 py-1">{product.Width} cm</td>
                    </tr>
                    <tr style={{ borderBottom: "1.99px solid gainsboro" }}>
                      <td>Largo</td>
                      <td className="ps-5 py-1">{product.Length} cm</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Product;
